// extracted by mini-css-extract-plugin
export var sidebar = "Sidebar-module--sidebar--I+I+R";
export var activeSidebar = "Sidebar-module--activeSidebar--rtQJy";
export var closeIcon = "Sidebar-module--closeIcon--pWHCk";
export var linksContainer = "Sidebar-module--linksContainer--v8j18";
export var signupButton = "Sidebar-module--signupButton--x1BMv";